import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BaseResponse, CheckInResponse, CheckedInResponse, 
         CheckOutResponse, PresenceTimeResponse, ExitCausesResponse, WorkedDateTimeResponse, 
         PresenceResponse, Presence, Entry, UserStatisticsResponse, PresenceDetailResponse, EnterCausesResponse } from "../core/core.component";
import { Http, Headers, URLSearchParams} from '@angular/http'; 
import { environment } from 'environments/environment';
import { AppConstants } from '../core/app.constants';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class PresenzeService
{
    private presenceDetailStatus = new Subject<Presence>();
    private selectPresenceSection = new Subject<boolean>();

    constructor(private http: Http, private datePipe: DatePipe) { }
    
    // servizi per interazione componenti
    getDetailStatus() : Observable<Presence> {
        return this.presenceDetailStatus.asObservable();
    }
    
    openPresenceDetail(presence: Presence) {
        this.presenceDetailStatus.next(presence);
    }

    closePresenceDetail() {
        this.presenceDetailStatus.next();
    }
    
    openPresenceSection() {
        this.selectPresenceSection.next(true);
    }
    
    selectPresenceSectionEvent() : Observable<boolean> {
        return this.selectPresenceSection.asObservable();
    }
    
    // Call REST
    serverTimestamp() : Observable<BaseResponse> 
    {
        var url = environment.REST_SERVICE_BASE_URL + "/ping/currentTimestamp";
        url = AppConstants.urlForNoCache(url);
        return this.http.get(url).map((responseData) => responseData.json());
    }
    
    checkIn(srmToken, causale:number): Observable<CheckInResponse> 
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/check-in";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.post(url, {idMotivEnt: causale}, {headers: headers}).map((responseData) => responseData.json());
    }
    
    isCheckedIn(srmToken): Observable<CheckedInResponse> 
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/ischeckedin";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
    }
    
    checkOut(srmToken, causale:number): Observable<CheckOutResponse> 
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/check-out";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.post(url, {idMotivUsc: causale}, {headers: headers}).map((responseData) => responseData.json());
    }
   
    timeworked(srmToken, data: Date, userId:number): Observable<PresenceTimeResponse> 
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/timeworked";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        let params: URLSearchParams = new URLSearchParams();
        params.set('date', this.datePipe.transform(data, "yyyy-MM-dd"));
        if(userId != null) {
            params.set('userID', userId.toString());
        }
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }

    timeworkedByRange(srmToken, dataStart: Date, dataEnd: Date, userId:number): Observable<WorkedDateTimeResponse> 
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/timeworkedrange";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        let params: URLSearchParams = new URLSearchParams();
        params.set('dateFrom', this.datePipe.transform(dataStart, "yyyy-MM-dd"));
        params.set('dateTo', this.datePipe.transform(dataEnd, "yyyy-MM-dd"));
        if(userId != null) {
            params.set('userID', userId.toString());
        }
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }
    
    getEnterCauses(srmToken, userId?:number): Observable<EnterCausesResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/entercauses";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        let params: URLSearchParams = new URLSearchParams();
        if(userId) {
            params.set('userID', userId.toString());
        }
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }
     
    getExitCauses(srmToken): Observable<ExitCausesResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/exitcauses";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
    }

    getPresences(srmToken, data: Date, userId: number): Observable<PresenceResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        let params: URLSearchParams = new URLSearchParams();
        params.set('date', this.datePipe.transform(data, "yyyy-MM-dd"));
        if(userId != null && userId != 0) {
            params.set('userID', userId.toString());
        }
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }
    
    getPresenceDetailInfo(srmToken,  presenceId: number): Observable<PresenceDetailResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/detail/" + presenceId;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
    }
    
    
    getPresencesPeriod(srmToken, dateFrom: Date, dateTo:Date, userId: number[]): Observable<PresenceResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        let params: URLSearchParams = new URLSearchParams();
        params.set('begin', this.datePipe.transform(dateFrom, "yyyy-MM-dd"));
        params.set('end', this.datePipe.transform(dateTo, "yyyy-MM-dd"));
        if(userId != null && userId.length > 0 ) {
            let ids: string = "";
            for(let i = 0; i < userId.length; ++i) {
                ids += userId[i];
                if(i != (userId.length -1)) {
                    ids +=",";
                }
            }
            params.set('userID', ids);
        }
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }
    
    updatePresence(srmToken, id: number, userId: number, date: Date, enter: string, enterCode: string, exit: string, exitCode: string) : Observable<BaseResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/" + id;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        let entry: Entry = new Entry();
        entry.date = this.datePipe.transform(date, "yyyy-MM-dd");
        
        if(enter!= null) {
            entry.entrance = enter;
        }
        if(enterCode!= null) {
            entry.idMotivEnt = enterCode;
        }
        if(exit != null) {
            entry.exit = exit;
        }
        if(exitCode != null) {
            entry.idMotivUsc = exitCode;
        }
        if(userId != null && userId > 0) {
            entry.idUser = userId;
        }
     
        return this.http.put(url, entry, {headers: headers}).map((responseData) => responseData.json());
    }
    
    insertPresence(srmToken, userId: number, date: Date, enter: string, enterCode: string, exit: string, exitCode: string) : Observable<Presence>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        let entry: Entry = new Entry();
        entry.date = this.datePipe.transform(date, "yyyy-MM-dd");
        entry.entrance = enter;

        if(enterCode != null) {
            entry.idMotivEnt = enterCode;
        }
        if(exit != null) {
            entry.exit = exit;
        }
        if(exitCode != null) {
            entry.idMotivUsc = exitCode;
        }
        if(userId != null && userId > 0) {
            entry.idUser = userId;
        }
     
        return this.http.post(url, entry, {headers: headers}).map((responseData) => responseData.json());
    }
    
    deletePresence(srmToken, id: number) : Observable<BaseResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/" + id;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        return this.http.delete(url, {headers: headers}).map((responseData) => responseData.json());
    }
    
    getUserStatistics(srmToken) : Observable<UserStatisticsResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/presences/mystatistics";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
            
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/service/presenze.service.ts